import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=73b649b9&scoped=true"
import script from "./Template.vue?vue&type=script&lang=ts"
export * from "./Template.vue?vue&type=script&lang=ts"
import style0 from "./Template.vue?vue&type=style&index=0&id=73b649b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b649b9",
  null
  
)

export default component.exports